import React from 'react'
import {ChevronDown, ChevronUp} from '../../icons'
import {components} from 'react-select'
import PropTypes from 'prop-types'
import {Box, Flex, Text, useMultiStyleConfig} from '@chakra-ui/react'

const CustomValueContainer = ({children, menuIsOpen, ...props}) => {
    const {selectProps} = props
    const hasSelectedValue = Boolean(selectProps.value?.value)
    const leftIcon = selectProps.leftIcon
    const selectedLeftIcon = hasSelectedValue
        ? typeof leftIcon === 'function'
            ? leftIcon(selectProps.value)
            : leftIcon
        : null
    const placeholderText = selectProps.placeholder
    const styles = useMultiStyleConfig('Dropdown')

    const childrenArray = React.Children.toArray(children)
    const inputChild = childrenArray[childrenArray.length - 1]
    const valueChildren = childrenArray.slice(0, -1)

    return (
        <components.ValueContainer {...props}>
            <Box display="flex" flexDirection="column" justifyContent="center" h="100%" w="100%">
                {hasSelectedValue && placeholderText && (
                    <Text {...styles.placeholderLabel}>{placeholderText}</Text>
                )}

                <Box display="grid" minW={0}>
                    {selectedLeftIcon && hasSelectedValue ? (
                        <Flex alignItems="center" gap="xxsmall.xl" gridArea="1 / 1 / 2 / 3">
                            {selectedLeftIcon}
                            {valueChildren}
                        </Flex>
                    ) : (
                        valueChildren
                    )}
                    {selectProps.isSearchable && inputChild}
                </Box>
            </Box>

            {menuIsOpen ? (
                <ChevronUp {...styles.dropdownIndicator} />
            ) : (
                <ChevronDown {...styles.dropdownIndicator} />
            )}

            {!selectProps.isSearchable && (
                <Box position="absolute" opacity={0} height={0} overflow="hidden">
                    {inputChild}
                </Box>
            )}
        </components.ValueContainer>
    )
}

export default CustomValueContainer

CustomValueContainer.propTypes = {
    children: PropTypes.node,
    hasSelectedValue: PropTypes.bool,
    menuIsOpen: PropTypes.bool,
    selectProps: PropTypes.object,
}
